import React, {Component} from 'react';
import PropTypes from 'prop-types';
import selectionTypesConstants from '../constants/selection_types_constants';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
// when the prop snapshot changes to true it should store a png under png prop
// then have a callback that 
const $3Dmol = require('3dmol');

const DEFAULT_FONT_SIZE = 14;

const simpleHash = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
  }
  // Convert to 32bit unsigned integer in base 36 and pad with "0" to ensure length is 7.
  return (hash >>> 0).toString(36).padStart(7, '0');
};

class Molecule3d extends React.Component {

  static render3dMolModel(glviewer, modelData) {
    const model = glviewer.addModel(modelData.data, modelData.format, {
      keepH: true,
    });
    return model
  }

  static render3dMolOrbital(glviewer, orbital) {
    if (orbital.cube_file) {
      const volumeData = new $3Dmol.VolumeData(orbital.cube_file, 'cube');
      if (typeof(orbital.options) == 'object') {
          if (glviewer.hasVolumetricRender() && (orbital.options.hasOwnProperty("transferfn"))) {
            return[glviewer.addVolumetricRender(volumeData, orbital.options)]
          }
      } else {
        var surfaces = []
        for (const options of orbital.options) {
          const s = glviewer.addIsosurface(volumeData, options)
          surfaces.push(s)
        }
      }
      return surfaces
      
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      selectedAtomIds: props.selectedAtomIds,
      selectedGroupIds: props.selectedGroupIds,
      atom_groups: props.atom_groups,
      selectionType: props.selectionType,
      snapshot: props.snapshot,
      png: props.png
    };

    this.lastOutline = { width: 0.0 };
    this.orbitalHashes = {}
    this.modelHash = null 
    this.model = null
    this.selected_model = null
  }

  componentDidMount() {
    this.render3dMol();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedAtomIds: nextProps.selectedAtomIds,
      selectedGroupIds: nextProps.selectedGroupIds,
      modelData: nextProps.modelData,
      isosurfaces: nextProps.isosurfaces,
      volumeRenders: nextProps.volumeRenders,
      atom_groups: nextProps.atom_groups,
      png: nextProps.png,
      snapshot: nextProps.snapshot,
      selectionType: nextProps.selectionType
    });
  }

  pngURI() {
    if (this.glviewer) {
      return this.glviewer.pngURI()
    }
    return null
  }

  componentDidUpdate() {
    this.render3dMol();
  }

  setupProps(props) {
    if (this.props.setProps) { 
      this.props.setProps({...this.state, ...props})

    } else {
      this.setState(prevState => ({...prevState, ...props}));
    }
  }

  onClickAtom = (glAtom) => {
    const selectionType = this.props.selectionType;
    if (selectionType === selectionTypesConstants.ATOM) {
      const newSelectedAtomIds = this.addSelection(
        this.state.selectedAtomIds,
        glAtom)
      
      this.setupProps({selectedAtomIds: newSelectedAtomIds, 
                       selectedGroupIds: []})
    }
    else if (selectionType === selectionTypesConstants.GROUP) {
      let selectedGroupIds = this.props.selectedGroupIds.slice()
      this.props.atom_groups.forEach((atom_group) => {
        if (atom_group.atoms.includes(glAtom.serial)) {
          let is_group_selected = selectedGroupIds.includes(atom_group.id)
          if (is_group_selected) {
            selectedGroupIds = selectedGroupIds.filter(id => id != atom_group.id)
          } else {
            selectedGroupIds.push(atom_group.id)
          }
        }
      });

      this.setupProps({selectedGroupIds: selectedGroupIds.slice(), 
                       selectedAtomIds: []});
    }

  }

  renderOrbitals(glviewer) {
    var orbitalHashes = {}
    this.props.isosurfaces.forEach((isosurface) => {
      const hsh = simpleHash(isosurface.cube_file)
      if (!(this.orbitalHashes.hasOwnProperty(hsh))) { // add new surfaces
        var surfaces = []
        const volumeData = new $3Dmol.VolumeData(isosurface.cube_file, 'cube');
        for (const options of isosurface.options) {
          const s = glviewer.addIsosurface(volumeData, options)
          surfaces.push(s)
        }
        orbitalHashes[hsh] = surfaces
      } else {
        orbitalHashes[hsh] = this.orbitalHashes[hsh]
      }
    }, this);

    this.props.volumeRenders.forEach((volumeRender) => {
      const hsh = simpleHash(volumeRender.cube_file)
      if (!(this.orbitalHashes.hasOwnProperty(hsh))) { // add new surfaces
        const volumeData = new $3Dmol.VolumeData(volumeRender.cube_file, 'cube');
        if (glviewer.hasVolumetricRender()) {
          orbitalHashes[hsh] = [glviewer.addVolumetricRender(volumeData, volumeRender.options)]
        }
      } else {
        orbitalHashes[hsh] = this.orbitalHashes[hsh]
      }
    }, this);
    
    for (const [hsh, sids] of Object.entries(this.orbitalHashes)) {
      if (!(hsh in orbitalHashes)) { // this orbital must have been removed
        sids.forEach((sid) => {
          this.glviewer.removeShape(sid)
        }, this);
      }
    }

    this.orbitalHashes = orbitalHashes
  }

  updateModel(glviewer, modelHash) {
    if (this.model) {
      glviewer.removeModel(this.model)
    }
    this.model = Molecule3d.render3dMolModel(glviewer, this.props.modelData);
    this.selected_model = Molecule3d.render3dMolModel(glviewer, this.props.modelData);
    this.selected_model.setClickable(false)
    this.model.setStyle({stick:{colorscheme:'magentaCarbon'}, sphere:{radius:0.5}});
    this.selected_model.setStyle({}, {sphere: {hidden: true, 
                                               opacity: this.props.selectionOpacity}, 
                                               stick:{hidden:true, opacity: this.props.selectionOpacity}})
    this.modelHash = modelHash
    if (typeof (this.props.nearClip) === 'number' && typeof (this.props.farClip) === 'number') {
      glviewer.setSlab(this.props.nearClip, this.props.farClip);
    } else {
      glviewer.fitSlab();
    }
    glviewer.zoom(0.8);
    glviewer.zoomTo();
    this.setupProps({selectedAtomIds: [], 
                      selectedGroupIds: [],
                      png: null,
                      snapshot: false})
    this.props.onRenderNewData(glviewer);
  }

  generateSnapshot() {
    this.setupProps({png: this.pngURI(), snapshot: false, selectionType: this.state.selectionType})
  }

  showSelectedGroupLabels() {
    // add a group label at the centroid
    // note if the atom labels already shown don't need to show selected
    this.props.atom_groups.forEach((atom_group) => {
      let fontColor = "white"
      if (atom_group.fontColor != null) {
        fontColor = atom_group.fontColor
      }
      if (this.props.selectedGroupIds.includes(atom_group.id)) {
        // group is selected
        var x = 0.0
        var y = 0.0
        var z = 0.0
        var n = 0
        this.model.atoms.forEach(atom => {
          if (atom_group.atoms.includes(atom.serial)) {
            x = x + atom.x
            y = y + atom.y
            z = z + atom.z
            n += 1
          }
        })
        this.glviewer.addLabel(atom_group.label, {
          fontSize: DEFAULT_FONT_SIZE,
          fontColor: fontColor,
          position: {
            x: x / n,
            y: y / n,
            z: z / n,
          },
          backgroundColor: "black",
          backgroundOpacity: this.props.labelOpacity
        });

      }
    })
  }

  showSelectedAtomLabels() {
    this.model.atoms.forEach(atom => {
      if (this.props.selectedAtomIds.includes(atom.serial)) {
        this.glviewer.addLabel(atom.elem + ": " + atom.serial, {
            fontSize: DEFAULT_FONT_SIZE,
            position: {
              x: atom.x,
              y: atom.y,
              z: atom.z,
            },
            backgroundColor: "black",
            backgroundOpacity: this.props.labelOpacity
          });
      }
    });
  }

  showSelectedAtoms() {
    this.selected_model.setStyle({}, {sphere: {hidden:true, opacity: this.props.selectionOpacity}, stick: {hidden:true, opacity: this.props.selectionOpacity}})
    this.props.selectedAtomIds.forEach((atom) => {
      let color = this.props.selectionColor
      this.props.atom_groups.forEach((group) => {
        if (group.atoms.includes(atom)) {
          color = group.color
        }
      })
      this.selected_model.setStyle({serial: atom}, 
        {sphere:{radius:0.5, 
                 scale: this.props.selectionScale, 
                 opacity: this.props.selectionOpacity, 
                 color:color, 
                 hidden: false},
         stick:{hidden:false, 
                color: color, 
                radius:0.25 * this.props.selectionScale, 
                opacity: this.props.selectionOpacity}});
    })
    if (this.model && this.props.showSelectedLabels) {
      this.showSelectedAtomLabels()
    }
  }

  showSelectedGroups() {
    this.props.atom_groups.forEach((atom_group) => {
      if (this.props.selectedGroupIds.includes(atom_group.id)) {
        atom_group.atoms.forEach((atom)=> {
          let color = this.props.selectionColor
          if (atom_group.color != null) {
            color = atom_group.color
          }
          this.selected_model.setStyle({serial: atom}, 
            {sphere:{radius:0.5, 
                     scale: this.props.selectionScale, 
                     opacity: this.props.selectionOpacity, 
                     color:color, hidden: false}, 
             stick:{hidden:false, 
                    color: color, 
                    radius:0.25 * this.props.selectionScale, 
                    opacity: this.props.selectionOpacity}});
        })
      } else {
        atom_group.atoms.forEach((atom)=> {
          let color = this.props.selectionColor
          if (atom_group.color != null) {
            color = atom_group.color
          }
          this.selected_model.setStyle({serial: atom}, 
            {sphere:{hidden: true, opacity: this.props.selectionOpacity, 
            }, 
             stick:{hidden: true, opacity: this.props.selectionOpacity, 
             }});
        })
      }
    })
    if (this.model && this.props.showSelectedLabels) {
      this.showSelectedGroupLabels()
    }
  }

  render3dMol() {
    const glviewer = this.glviewer || $3Dmol.createViewer(this.container, {
      antialias: true,
      defaultcolors: $3Dmol.elementColors.Jmol,
    });
    glviewer.removeAllLabels()
    glviewer.setBackgroundColor(
      this.props.backgroundColor,
      this.props.backgroundOpacity
    );
    glviewer.setClickable({}, true, this.onClickAtom);
    if (this.state.modelData) {
      const hsh = simpleHash(this.props.modelData.data)
      
      if (hsh != this.modelHash) { 
        this.updateModel(glviewer, hsh)
      }
            
      if (this.state.snapshot == true) {
        this.generateSnapshot()
      }
    }
  
    if (this.props.selectionType === selectionTypesConstants.GROUP) {
        this.showSelectedGroups()
    }
    else if (this.model && this.props.showSelectedLabels) {
      this.showSelectedAtoms()
    }

    this.renderOrbitals(glviewer)

    glviewer.render();
    this.glviewer = glviewer;
  }

  addSelection(selectedAtoms, clickedAtom){
    let selectedAtomsOut = selectedAtoms.slice();
    const clickedIndex = selectedAtoms.indexOf(clickedAtom.serial);
    const toggleOn = clickedIndex === -1;
    if (toggleOn) {
      selectedAtomsOut.push(clickedAtom.serial);
    } else {
      selectedAtomsOut.splice(clickedIndex, 1);
    }
    return selectedAtomsOut;
  }

  render() {
    return (
      <div style={{width: this.props.width, 
         display: 'flex', 
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'center'}}>
        <div id={this.props.id}
          className="molecule-3d"
          style={{
            width: this.props.width,
            height: this.props.height,
            position: 'relative'
          }}
          ref={(c) => { this.container = c; }}
        />
        <div id="buttons"
        style={{width: this.props.width, display: 'flex', 'justify-content': 'left'}}>
        </div>
      </div>
    );
  }
}

Molecule3d.propTypes = {
  id: PropTypes.string,
  showSelectedLabels: PropTypes.bool,
  backgroundColor: PropTypes.string,
  backgroundOpacity: PropTypes.number,
  height: PropTypes.string,
  modelData: PropTypes.shape({
    data: PropTypes.string,
    format: PropTypes.string,
  }),
  onChangeSelection: PropTypes.func,
  onRenderNewData: PropTypes.func,
  isosurfaces: PropTypes.arrayOf(
    PropTypes.shape({options: PropTypes.arrayOf(
      PropTypes.shape({
      isoval: PropTypes.number,
      color: PropTypes.string,
      opacity: PropTypes.number})),
    cubeFile: PropTypes.string})),
  atom_groups: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.number,
                                                  atoms: PropTypes.arrayOf(PropTypes.number),
                                                  color: PropTypes.string,
                                                  label: PropTypes.string})),
  volumeRenders: PropTypes.arrayOf(
    PropTypes.shape({
    options: PropTypes.shape({
      subsamples: PropTypes.number,
      transferfn: PropTypes.arrayOf(PropTypes.shape({color: PropTypes.string, 
                                                     opacity: PropTypes.number, 
                                                     value: PropTypes.number}))
    }),
    cubeFile: PropTypes.string
  })),
  selectionOpacity: PropTypes.number,
  selectionScale: PropTypes.number,
  selectionColor: PropTypes.string,
  selectedAtomIds: PropTypes.arrayOf(PropTypes.number),
  selectedGroupIds: PropTypes.arrayOf(PropTypes.number),
  selectionType: PropTypes.oneOf([
    selectionTypesConstants.ATOM,
    selectionTypesConstants.GROUP,
    selectionTypesConstants.RESIDUE,
    selectionTypesConstants.CHAIN,

  ]),
  width: PropTypes.string,
  nearClip: PropTypes.number,
  farClip: PropTypes.number,
  outlineWidth: PropTypes.number,
  outlineColor: PropTypes.string,
  labelOpacity: PropTypes.number,
  snapshot: PropTypes.bool,
  png: PropTypes.string
}

Molecule3d.defaultProps = {
  backgroundOpacity: PropTypes.float = 0.0,
  backgroundColor: PropTypes.str = '#73757c',
  height: '500px',
  onRenderNewData: () => {},
  isosurfaces: [],
  volumeRenders: [],
  atom_groups: [],
  snapshot: false,
  selectionOpacity: 0.8,
  selectionScale: 1.2,
  selectionColor: "white",
  selectedAtomIds: [],
  selectedGroupIds: [],
  labelOpacity: 0.5,
  selectionType: selectionTypesConstants.GROUP,
  showSelectedLabels: true,
  width: '500px',
  outlineWidth: 0.0,
  outlineColor: '#000000',
  nearClip: null,
  farClip: null,
  png: null
}


export default Molecule3d;

